import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import {
  confirmSignUp,
  signIn,
  signUp,
  updateUserAttributes,
  fetchUserAttributes,
  resendSignUpCode,
  resetPassword,
  confirmResetPassword,
  signInWithRedirect,
  fetchAuthSession,
  AuthSession,
} from 'aws-amplify/auth';
import { User } from 'app/core/interfaces/user';
import { OrganizationService } from './organization.service';
import { PractitionerService } from './practitioner.service';
import { PatientService } from './patient.service';
import { SecretaryService } from './secretary.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'app/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CognitoService {
  constructor(
    public organizationService: OrganizationService,
    public practitionerService: PractitionerService,
    public patientService: PatientService,
    public secretaryService: SecretaryService,
    private router: Router
  ) {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolClientId: environment.userPoolClientId,
          userPoolId: environment.userPoolId,
          loginWith: {
            oauth: {
              domain: environment.oAuthDomain,
              scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
              redirectSignIn: environment.oAuthRedirectSignIn,
              redirectSignOut: environment.oAuthRedirectSignOut,
              responseType: 'code',
            },
          },
        },
      },
    });

    

   
  }

  ngOnInit(){
console.log("entrei cognitooo")
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl(uri).then(() => window.location.reload());
  }

  public signIn(user: User): Promise<any> {
    return signIn({
      username: user.email,
      password: user.password,
    });
  }

  public signUp(user: User): Promise<any> {
    return signUp({
      username: user.email,
      password: user.password,
      options: {
        userAttributes: {
          'custom:type': user.type,
          'custom:firstAccess': 'true',
        },
      },
    });
  }

  public signUpSubUser(user: User): Promise<any> {
    return signUp({
      username: user.email,
      password: user.password,
      options: {
        userAttributes: {
          'custom:type': user.type,
          'custom:firstAccess': 'false',
        },
      },
    });
  }

  public confirmSignUp(user: User) {
    return confirmSignUp({
      username: user.email,
      confirmationCode: user.code!,
    });
  }

  public getUser(type: string, sub: string): Observable<any> {
    switch (type) {
      case 'organization':
        return this.organizationService.searchByToken(sub);
      case 'secretary':
        return this.secretaryService.searchByToken(sub);
      case 'practitioner':
        return this.practitionerService.searchByToken(sub);
      default:
        return this.patientService.searchByToken(sub);
    }
  }

  async updateFirstAccess() {
    try {
      await updateUserAttributes({
        userAttributes: {
          'custom:firstAccess': 'false',
        },
      });

      localStorage.setItem("isFirstAccess", 'false')

      return true

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async updateUserType(type: string) {
    try {
      await updateUserAttributes({
        userAttributes: {
          'custom:type': type,
        },
      });

      setTimeout(function () {
        location.reload();
      }, 3000);

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async getUserAttributes(email?: string) {
    try {
      const attributes: Record<string, any> = await fetchUserAttributes();
      const standardAttributes: Record<string, any> = {};
      const customAttributes: Record<string, any> = {};

      for (const key in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, key)) {
          if (key.startsWith('custom:')) {
            customAttributes[key.substring('custom:'.length)] = attributes[key];
          } else {
            standardAttributes[key] = attributes[key];
          }
        }
      }

      return { standardAttributes, customAttributes };
    } catch (error) {
      this.router.navigate(['confirmar-conta'], {
        queryParams: { email: email },
      });
      throw error;
    }
  }

  async reSendCode(email: any) {
    await resendSignUpCode({
      username: email,
    });
  }

  public sendPasswordResetCode(email: string) {
    return resetPassword({
      username: email,
    });
  }

  public resetPassword(email: string, newPass: string, confirmCode: string) {
    return confirmResetPassword({
      username: email,
      newPassword: newPass,
      confirmationCode: confirmCode,
    });
  }

  public async googleLogin() {
      
    try {
      await signInWithRedirect({
        provider: 'Google',
      });

   
    } catch (error) {
      console.error('Error during Google login:', error);
    }
  }

  public async refreshToken(): Promise<void> {
    try {
      const session: AuthSession = await fetchAuthSession({ forceRefresh: true });
      const accessToken = session.tokens?.idToken?.toString();

      if (accessToken) {
        localStorage.setItem('userTokenId', accessToken);
      } else {
        this.router.navigate(['/login']);
        throw new Error('Não foi possível obter os tokens da sessão.');
      }
    } catch (error) {
      console.error('Erro ao renovar o token:', error);
      this.router.navigate(['/login']);
      throw error;
    }
  }
}
